
import { defineComponent, onMounted } from 'vue'
import SecondFooter from '@/components/SecondFooter.vue'
import { routGo } from '@/hooks/links'

export default defineComponent({
  name: 'Studio',
  components: {
    SecondFooter
  },
  setup(){
    onMounted(() => {
      _hmt.push(['_trackPageview', '/studio'])
    })
    return { routGo }
  }
})
